var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg08Overheat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#bot{transform-origin:120px 200px;animation:shiver .5s ease-in-out infinite}\n@keyframes shiver{0%,100%{transform:translateX(-2px)}50%{transform:translateX(2px)}}\n.heat{animation:rise 2.2s ease-out infinite;opacity:0}\n.w2{animation-delay:.7s}.w3{animation-delay:1.4s}\n@keyframes rise{0%{opacity:0;transform:translateY(6px) scaleY(.7)}30%{opacity:.9}100%{opacity:0;transform:translateY(-40px) scaleY(1.2)}}\n#drop{animation:drip 1.8s ease-in infinite;opacity:0}\n@keyframes drip{0%{opacity:0;transform:translateY(-6px)}20%{opacity:1}70%{opacity:1;transform:translateY(26px)}100%{opacity:0;transform:translateY(34px)}}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FF7A59",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    className: "heat",
    d: "M78 56 q8 -12 0 -24 q-8 -12 0 -24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "heat w2",
    d: "M120 52 q8 -12 0 -24 q-8 -12 0 -24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "heat w3",
    d: "M162 56 q8 -12 0 -24 q-8 -12 0 -24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "bot"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 62,
    width: 160,
    height: 146,
    rx: 52,
    fill: "#FF9D7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 124 q14 -14 28 0",
    fill: "none",
    stroke: "#3A1508",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 124 q14 -14 28 0",
    fill: "none",
    stroke: "#3A1508",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 166 q20 -18 40 0",
    fill: "none",
    stroke: "#3A1508",
    strokeWidth: 9,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drop",
    d: "M176 96 c0 0 -11 14 -11 21 a11 11 0 0 0 22 0 c0 -7 -11 -21 -11 -21 z",
    fill: "#8FD6FF",
    stroke: "#3A1508",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08Overheat);
export default __webpack_public_path__ + "static/media/08-overheat.1464a67e4e6447541bcd6facd07316b2.svg";
export { ForwardRef as ReactComponent };